export default "__VITE_ASSET__Bqpf3xnu__"